<template>
  <div class="block md:hidden">
    <div v-if="editing">

      <div v-if="currentStep === 2" class="button-mobile-version">
        <div :class="{'text-center': currentStep === 0, 'wizard-footer-left ml-5': currentStep > 0 , buttonsFullWidth : currentStep === 2}">
          <vs-button id="edit-campaign-update-button" v-if="canUpdateDetails && currentStep === 2" @click.native="$parent.$parent.$parent.updateCampaignInfo" class="update-campaign-update-button w-40 p-3 button-border-radius shadow-none mr-5" color="primary" type="filled">
            {{ $t('Update') }}
          </vs-button>

          <vs-button id="edit-campaign-next-button" v-bind:class="{ mainButton: currentStep === 1 || currentStep === 3 || currentStep === 4 , updateCampaignNextButton : currentStep === 2 }" v-if="!(currentStep === 5)" @click.native="nextTab()" class="update-campaign-next-button w-40 p-3 button-border-radius shadow-none" color="" type="">
            {{ $t('Next') }}
          </vs-button>

          <vs-button id="edit-campaign-update-adset-button" v-else @click.native="$parent.$parent.$parent.updateCampaign('step2')" class="font-light w-40 button-border-radius shadow-none wizard-footer-right finish-button" color="primary" type="filled">
            {{ $t('Update Adsets') }}
          </vs-button>
        </div>

        <div v-bind:class="{buttonsFullWidth : currentStep === 2}" class="back-button-mobile-version wizard-footer-left">
          <vs-button  v-if="currentStep > 1" @click.native="back()" class="update-campaign-back-button back-button-border-radius back-button" color="" type="">
            <img class="back-button-arrow" src="@/assets/images/campaigns-table-actions/back.svg" alt="">
            {{ $t('Back') }}
          </vs-button>
        </div>
      </div>

      <div v-if="currentStep !== 2" class="button-mobile-version">

        <div class="text-center mt-6" :class="{'text-center': currentStep === 0, 'wizard-footer-left': currentStep > 0 , buttonsFullWidth : currentStep === 2}">
          <vs-button v-if="canUpdateDetails && currentStep === 2" @click.native="$parent.$parent.$parent.updateCampaignInfo" class="update-campaign-update-button w-40 p-3 button-border-radius shadow-none mr-5" color="primary" type="filled">
            {{ $t('Update') }}
          </vs-button>

          <div v-if="!isLeadForm">
            <div v-if="!(currentStep === 5)">
              <vs-button v-bind:class="{ mainButton: currentStep === 1 || currentStep === 3 || currentStep === 4 , updateCampaignNextButton : currentStep === 2 , buttonsFullWidth : currentStep !== 1 }" @click.native="nextTab()" class="mb-4 update-campaign-next-button w-40 p-3 button-border-radius shadow-none" color="" type="">
                {{ $t('Next') }}
              </vs-button>
            </div>

            <div v-else>
              <vs-button v-bind:class="{buttonsFullWidth : currentStep === 5}" @click.native="$parent.$parent.$parent.updateCampaign('step5')" class="mb-4 font-light w-40 button-border-radius shadow-none wizard-footer-right finish-button" color="primary" type="filled">
                {{ $t('Update Adsets') }}
              </vs-button>
            </div>
          </div>

           <div v-else-if="isLeadForm">
            <div v-if="!(currentStep === 6)">
              <vs-button v-bind:class="{ mainButton: currentStep === 1 || currentStep === 3 || currentStep === 4 || currentStep === 5 , updateCampaignNextButton : currentStep === 2 , buttonsFullWidth : currentStep !== 1 }" @click.native="nextTab()" class="mb-4 update-campaign-next-button w-40 p-3 button-border-radius shadow-none" color="" type="">
                {{ $t('Next') }}
              </vs-button>
            </div>

            <div v-else>
              <vs-button v-bind:class="{buttonsFullWidth : currentStep === 6}" @click.native="$parent.$parent.$parent.updateCampaign('step6')" class="mb-4 font-light w-40 button-border-radius shadow-none wizard-footer-right finish-button" color="primary" type="filled">
                {{ $t('Update Adsets') }}
              </vs-button>
            </div>
          </div>

          <div v-bind:class="{buttonsFullWidth : currentStep !== 2}" class="back-button-mobile-version wizard-footer-left">
            <vs-button  v-if="currentStep > 1" @click.native="back()" class="mb-4 update-campaign-back-button back-button-border-radius back-button" color="" type="">
              <img class="back-button-arrow" src="@/assets/images/campaigns-table-actions/back.svg" alt="">
              {{ $t('Back') }}
            </vs-button>
          </div>

        </div>

      </div>

    </div>

    <div v-else>

      <div class="next-xs-mobile-version" :class="{'text-center': currentStep === 0, 'wizard-footer-left': currentStep > 0}">
        <div v-if="!isLeadForm">
          <div v-if="!(currentStep === 5)">
            <vs-button @click.native="nextTab()" class="w-40 mb-4 p-3 button-border-radius shadow-none" color="primary" type="filled">
              {{ $t('Next') }}
            </vs-button>
          </div>

          <div v-else>
            <vs-button @click.native="$parent.$parent.$parent.submitCampaign('step5')" class="w-40 mb-4 p-3 button-border-radius shadow-none wizard-footer-right finish-button" color="primary" type="filled">
              {{ $t('Launch') }}
            </vs-button>
          </div>
        </div>

        <div v-else-if="isLeadForm">
          <div v-if="!(currentStep === 6)">
            <vs-button @click.native="nextTab()" class="w-40 mb-4 p-3 button-border-radius shadow-none" color="primary" type="filled">
              {{ $t('Next') }}
            </vs-button>
          </div>

          <div v-else>
            <vs-button @click.native="$parent.$parent.$parent.submitCampaign('step6')" class="w-40 mb-4 p-3 button-border-radius shadow-none wizard-footer-right finish-button" color="primary" type="filled">
              {{ $t('Launch') }}
            </vs-button>
          </div>
        </div>
      </div>

      <div class="back-xs-mobile-version wizard-footer-left">
        <vs-button v-if="currentStep > 1" @click.native="back()" class="back-button-style w-40 back-button-border-radius back-button" color="" type="">
          {{ $t('Back') }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    },
    canUpdateDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    isLeadForm: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    nextTab () {
      this.$parent.$parent.nextTab()
    },
    back () {
      this.$parent.$parent.prevTab()
    }
  }
}
</script>

<style lang="scss">
  @media (max-width: 576px) {
    .next-xs-mobile-version {
      text-align: center;
      margin-top: 20px;
    }

    .back-xs-mobile-version {
      float: left;
      // margin-left:7px;
      margin-bottom: 10px;
      width: 100%;

      .back-button-style {
        width: 100% !important;
      }
    }

    .next-xs-mobile-version {
      width: 100%;

      button {
        width: 100% !important;
      }
    }
  }
</style>
